import type { TFunction } from '@cobliteam/i18n';
import { type Category, EnumCategory, EnumCategoryType, EnumSidebar, type Sidebar } from './types';

export const useFleetCategories = (t: TFunction): Category[] => {
  return [
    {
      id: EnumCategory.VEHICLES,
      name: t('sidebar.vehicles', { ns: 'global-search' }),
      label: t('sidebar.vehicles', { ns: 'global-search' }),
      icon: 'truck',
      type: EnumCategoryType.ITEMS,
      color: 'primary',
      labelKey: 'label',
    },
    {
      id: EnumCategory.DRIVERS,
      name: t('sidebar.drivers', { ns: 'global-search' }),
      label: t('sidebar.drivers', { ns: 'global-search' }),
      icon: 'user',
      type: EnumCategoryType.ITEMS,
      color: 'warning',
      labelKey: 'name',
    },
    {
      id: EnumCategory.DEVICES,
      name: t('sidebar.devices', { ns: 'global-search' }),
      label: t('sidebar.devices', { ns: 'global-search' }),
      icon: 'router',
      type: EnumCategoryType.ITEMS,
      color: 'accessory-purple',
      labelKey: 'cobliId',
    },
    {
      id: EnumCategory.VEHICLE_GROUPS,
      name: t('sidebar.groups', { ns: 'global-search' }),
      label: t('sidebar.groups', { ns: 'global-search' }),
      icon: 'cb-filters-vehicle-group-cb',
      type: EnumCategoryType.ITEMS,
      color: 'success',
      labelKey: 'name',
    },
    {
      id: EnumCategory.GEOFENCES,
      name: t('sidebar.places_of_interest', { ns: 'global-search' }),
      label: t('sidebar.places_of_interest', { ns: 'global-search' }),
      icon: 'map-pin',
      type: EnumCategoryType.ITEMS,
      color: 'accessory-sky',
      labelKey: 'name',
    },
  ];
};

export const useGlobalSidebarDef = (t: TFunction): Sidebar => {
  const fleetCategories = useFleetCategories(t);

  return [
    {
      id: EnumSidebar.ALL,
      name: t('sidebar.all'),
      hideTitle: true,
      categories: [
        {
          id: EnumCategory.ALL,
          name: t('sidebar.all'),
          label: t('sidebar.all'),
          icon: 'list-filter',
          type: EnumCategoryType.ITEMS,
          color: 'gray',
          labelKey: 'label',
        },
      ],
    },
    {
      id: EnumSidebar.PAGES,
      name: t('sidebar.pages'),
      hideTitle: true,
      categories: [
        {
          id: EnumCategory.PAGES,
          name: t('sidebar.pages'),
          label: t('sidebar.pages'),
          icon: 'file-text',
          type: EnumCategoryType.ITEMS,
          color: 'gray',
          labelKey: 'title',
        },
      ],
    },
    {
      id: EnumSidebar.FLEET,
      name: t('sidebar.fleet_data'),
      categories: fleetCategories,
    },

    {
      id: EnumSidebar.DOCUMENTS,
      name: t('sidebar.documents'),
      categories: [
        // {
        //   id: EnumCategory.IA_ARTICLES,
        //   loading: false,
        //   name: 'Busca Inteligente (IA)',
        //   label: 'Busca Inteligente (IA)',
        //   icon: 'sparkles',
        //   type: EnumCategoryType.IA,
        //   color: 'gray',
        //   labelKey: 'query',
        // },
        {
          id: EnumCategory.ARTICLES,
          loading: false,
          name: t('sidebar.articles'),
          label: t('sidebar.articles'),
          icon: 'newspaper',
          type: EnumCategoryType.ITEMS,
          color: 'gray',
          labelKey: 'title',
        },
      ],
    },
  ];
};

export default useGlobalSidebarDef;
